export default {
    controller: 'orderCreateController',
    template: require('../views/order.create.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/orderCreation/components/order.create.component.js